var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/likes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/likes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9204692,7.06088704 C17.229599,6.38162964 16.2923833,6 15.315116,6 C14.3378487,6 13.400633,6.38162964 12.7097629,7.06088704 L11.9998209,7.75856813 L11.2898789,7.06088704 C9.85098206,5.64684041 7.51806941,5.64684043 6.07917261,7.06088707 C4.64027581,8.47493372 4.64027579,10.7675563 6.07917257,12.181603 L6.78911456,12.8792841 L11.9998209,18 L17.2105272,12.8792841 L17.9204692,12.181603 C18.6116637,11.5026644 19,10.5816346 19,9.621245 C19,8.66085537 18.6116637,7.73982565 17.9204692,7.06088704 Z",
    id: "Path",
    stroke: "#B2B2B2",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikes);
export default __webpack_public_path__ + "static/media/likes.7540029d79e06190db1324bcda0d3105.svg";
export { ForwardRef as ReactComponent };